import * as React from "react";
import { Viewport, ViewMedium, ViewSmall } from "bernie-view";
import { UitkIconSize, UitkIcon } from "uitk-react-icons";

export const SwapLocations = ({ swapLocations }: { swapLocations: () => void }) => {
  return (
    <>
      <Viewport>
        <ViewMedium>
          <div className="SwapLocationsDesktop" onClick={swapLocations}>
            <UitkIcon name="swap_vert" id="swapLocations" size={UitkIconSize.MEDIUM} />
          </div>
        </ViewMedium>
        <ViewSmall>
          <div className="SwapLocations" onClick={swapLocations}>
            <UitkIcon className="all-l-padding-half" name="swap_vert" id="swapLocations" size={UitkIconSize.MEDIUM} />
          </div>
        </ViewSmall>
      </Viewport>
    </>
  );
};
